<template>
  <div>
    <div class="chat-container mt-4" ref="chatContainer" style="overflow-y: scroll; max-height: 300px;">
    <div v-for="(obs, index) in observationOrder" :key="obs.id">
        <div class="chat-message" :class="{ 'last-message': index === observationOrder.length - 1 }">
            <div class="chat-bubble" :class="{ 'chat-bubble-right': id_user == obs.id_user }">
                <div class="row">
                    <div class="col-md-2">
                        <img v-if="obs.user" :src="obs.user.url_image" width="70" height="70" class="rounded-circle" alt="Avatar">
                    </div>
                    <div class="col-md-8"  >
                        <div style="line-height: 20px !important">
                            <span style="font-size: 16px" v-if="obs.user"><strong>{{obs.user.full_name}}</strong></span><br>
                            <span style="font-size: 13px">{{obs.message}}</span><br>
                            <span style="font-size: 10px">{{obs.created_at}}</span>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <button type="button" v-if="id_user == obs.id_user" class="btn btn-primary btn-sm" @click="deleteObservation(obs.id)">
                            <v-icon name="trash" fill="white"></v-icon>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
    <form class="mt-4" @submit.prevent>  
    <div class="input-group">  
        <input  
            type="text"  
            v-model="message"  
            class="form-control"  
            placeholder="Escribe tu observación"  
            aria-label="Escribe tu mensaje"  
            aria-describedby="button-addon"  
            v-on:keyup.enter="createObservation"  
        />  
        <button @click="createObservation" class="btn btn-primary" type="button" id="button-addon">  
            Enviar  
        </button>  
    </div>  
</form>
  </div>
</template>

<script>
//Vue Instance
import Cookies from "js-cookie";
import { mapState } from "vuex";
import { mapActions } from "vuex";
import moment from "moment";
export default {
  name: "ObservationChat",
  props: {
    //Props
    id_club: {
     
      default: 0,
    },
    id_user:0
  },
  data() {
    return {
      observationOrder: {},
      message:'',
     
    };
  },
  mounted() {
    console.log('ID USER'+this.id_user)
    this.loadObservations();
    this.scrollToBottom();
  },
  updated() {
    this.scrollToBottom();
},
  methods: {
    ...mapActions(["getData", "changeStatusData","createData","changeStatusData"]),

    scrollToBottom() {
      this.$nextTick(() => {
            const chatContainer = this.$refs.chatContainer;
            chatContainer.scrollTop = chatContainer.scrollHeight;
        });
    },
    deleteObservation(id_observation) {
      
      Swal.fire({
        title: 'Deseas eliminar esta observación',
        text: '',
        icon: "question",
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonColor: "#B49B57",
        cancelButtonColor: "#abb2ba",
        confirmButtonText: "Eliminar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          let form = {
            id: id_observation,
            url: "observation/change_status",
            status: 2,
          };
          this.changeStatusData(form)
            .then((response) => {
              if (response.code === 200) {
                this.loadObservations();
                
                Swal.fire({
                  title: 'Observación eliminada',
                  icon: "success",
                });
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },
    createObservation(){
        
        let data_form={
            id_club: this.id_club,
            message: this.message,
            id_user: this.id_user
        }
        let form = {
              url: "observation/save",
              data: data_form,
            };
            this.createData(form)
              .then((response) => {
                if (response.code === 200) {
                  this.deleting = false;
                  Swal.fire({
                    title: "Observacion agregada",
                    icon: "success",
                    showConfirmButton: false,
                    showLoaderOnConfirm: true,
                    timer: 1000,
                  });


                  this.message = "";
                  this.loadObservations();


                }
              })
              .catch((error) => {
                console.log(error);
                this.deleting = false;
                alert("Ocurrió un error, intente más tarde");

              });
          
    },
    loadObservations() {
        let id_club = this.id_club;
      console.log("LOAD OBSERVATIONS" + id_club);
      let form = {
        url: "observation/all",
        params: {
          id_club: parseInt(id_club),
        },
      };

      this.isBusy = true;
      this.getData(form)
        .then((response) => {
          this.isBusy = false;
          if (response.code === 200) {
            this.observationOrder = response.data;
            console.log(this.observationOrder);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
 
 
};
</script>

<style >
/* Estilos generales del chat */
.chat-container {
    
    margin: 0 auto;
    border: 1px solid #ccc;
    padding: 10px;
    border-radius: 10px;
}

.chat-message {
    margin: 10px 0;
}

/* Estilos para las burbujas de mensajes */
.chat-bubble {
    background-color: #f5f5f5;
    padding: 15px;
    border-radius: 30px;
    max-width: 90%;
    word-wrap: break-word;
}
.chat-bubble-right {
    background-color: #e8e3d4;
    padding: 15px;
    margin-left:10%;
   
    border-radius: 30px;
    max-width:90%;
    word-wrap: break-word;
}


.text-white {
    color:#fff !important;
}
/* .last-message .chat-bubble {
    background-color: #DCF8C6; 
    border-radius: 10px; 
    padding: 10px; 
}

.last-message .chat-bubble-right {
    background-color: #DCF8C6; 
} */
</style>